import { RETRIEVE_CLINIQUES } from "./types";

export const retrieveCliniques = (cliniques) => {
    return {
        type: RETRIEVE_CLINIQUES,
        payload: cliniques,
    };
};